import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { toNumber, find } from 'lodash'

/**
 */
class HelpFilter extends Component {
  /**
   * C'tor
   * @param props
   */
  constructor (props) {
    super(props)
    this.matchLevel = this.matchLevel.bind(this)
  }

  matchLevel (i) {
    return toNumber(i) === toNumber(this.props.helpLevel)
  }

  /**
   * Render the component
   * @returns
   */
  render () {
    const textDisplayNone = {
      display: 'none'
    }
    const textDisplayInline = {
      display: 'inline'
    }
    console.log(
      'showLevel, helpLevel',
      this.props.showLevel,
      this.props.helpLevel
    )
    if (find(this.props.showLevel, this.matchLevel)) {
      return <span style={textDisplayInline}> {this.props.children} </span>
    } else {
      return <span style={textDisplayNone}> {this.props.children} </span>
    }
  }
}

HelpFilter.propTypes = {
  showLevel: PropTypes.array
}

export function mapStateToProps (state) {
  return {
    helpLevel: state.get('app').get('helpLevel')
  }
}

export default connect(mapStateToProps)(HelpFilter)



// WEBPACK FOOTER //
// ./src/components/sections/HelpFilter.js